import store from './store/Store';
import { IConfig } from './interface/IConfig';
import HashEvent from './common/HashEvent';
import YearSelect from './components/YearSelect';
import ServerSelect from './components/ServerSelect';
import CardList from './components/CardList';
import ScrollToLoad from './libs/ScrollToLoad';
import Nodata from './components/Nodata';
import Loading from './components/Loading';

class App {
    private yearSel: YearSelect = new YearSelect();
    private svrSel: ServerSelect = new ServerSelect();
    private cardList: CardList = new CardList();
    
    constructor(_option:IConfig) {
        store.CommonDataStore.config = _option;

        new Loading();
        new Nodata();
        this.loadDataStart();
    }
    
    async loadDataStart(){
        await store.CategoryDataStore.getData();
        
        this.yearSel.draw(store.CategoryDataStore.yearData);
        this.svrSel.draw(store.CategoryDataStore.serverData);

        ScrollToLoad.instance.init( window, {except: 100});
        ScrollToLoad.instance.addCallback(()=>{
            if (store.CommonDataStore.isLast) return;
            store.CommonDataStore.addNowPage();
            store.CardDataStore.getData(store.CommonDataStore.nowYear, store.CommonDataStore.nowServer);
        });

        HashEvent.instance.init();
        HashEvent.instance.addCallback(( _y: string, _s: string )=>{
            store.CommonDataStore.reSetAllData(_y, _s);
            this.yearSel.update(_y, _s);
            this.svrSel.update(_y, _s);
            this.cardList.clearList();
            store.CardDataStore.getData(_y, _s);
        });
        HashEvent.instance.fire();
    }

} // end of class

window.updateHistory = App;